export default __webpack_public_path__ + "static/media/appicon.235e51c1.png";